import React from 'react';

export const Mandatory = ({ visible= true, children }) => <>
    {children}
    {visible && <span className="ml-3 mandatory">*</span>}
  </>